module.exports = __webpack_public_path__ + "static/media/landing.edf4fee9.png";